import { API_BASE, getAuthHeaders } from './config';

/** ---------- CATEGORIES ---------- */

export type Category = {
    id: number;
    title: string;
    picture?: string | null;
    created_by?: number | null;
    last_edited_by?: number | null;
    created_by_email?: string | null;
    last_edited_by_email?: string | null;
    created_at?: string;
    last_edited_at?: string | null;
    picture_url?: any;
};

export const listCategories = async (): Promise<Category[]> => {
    const res = await fetch(`${API_BASE}/categories`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    const data = await res.json();
    return Array.isArray(data?.items) ? data.items : [];
};

export const createCategory = async (title: string, picture?: string | null) => {
    const res = await fetch(`${API_BASE}/categories`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify({ title, picture: picture ?? null }),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

export const updateCategory = async (
    id: number,
    data: Partial<Pick<Category, 'title' | 'picture'>>
) => {
    const res = await fetch(`${API_BASE}/categories/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

export const deleteCategory = async (id: number) => {
    const res = await fetch(`${API_BASE}/categories/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

export const getCategory = async (id: number) => {
    const res = await fetch(`${API_BASE}/categories/${id}`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json();
};

export const getAdminContentsByCategory = async (id: number) => {
    const res = await fetch(`${API_BASE}/admin/categories/${id}/contents`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

export const getUserContentsByCategory = async (id: number) => {
    const res = await fetch(`${API_BASE}/user/categories/${id}/contents`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

/** Upload/Remove picture */
export const uploadCategoryPicture = async (id: number, file: File) => {
    const fd = new FormData();
    fd.append('picture', file);
    const res = await fetch(`${API_BASE}/categories/${id}/picture`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: fd,
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

export const deleteCategoryPicture = async (id: number) => {
    const res = await fetch(`${API_BASE}/categories/${id}/picture`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};
